let BRANDNAME = process.env.NEXT_PUBLIC_BRAND_NAME
  ? process.env.NEXT_PUBLIC_BRAND_NAME.toLowerCase()
  : "pei";

let PEIURL = "";
const BASEURL =
  process.env.NEXT_PUBLIC_BASE_URL ||
  process.env.BASE_URL ||
  "https://ra-api.stage.pei-services.com/api";
const isStageUrl = BASEURL?.includes("stage") ? true : false;

switch (BRANDNAME) {
  case "pei":
    PEIURL = isStageUrl
      ? "https://stage.privateequityinternational.com"
      : "https://www.privateequityinternational.com";
    break;
  case "npm":
    PEIURL = isStageUrl
      ? "https://stage.newprivatemarkets.com"
      : "https://www.newprivatemarkets.com";
    break;
  case "pdi":
    PEIURL = isStageUrl
      ? "https://stage.privatedebtinvestor.com"
      : "https://www.privatedebtinvestor.com";
    break;
  case "buyout":
    PEIURL = isStageUrl ? "https://stage.buyoutsinsider.com" : "https://www.buyoutsinsider.com";
    break;
  case "pere":
    PEIURL = isStageUrl ? "https://stage.perenews.com" : "https://www.perenews.com";
    break;
  case "ii":
    PEIURL = isStageUrl
      ? "https://stage.infrastructureinvestor.com"
      : "https://www.infrastructureinvestor.com";
    break;
  case "pehub":
    PEIURL = isStageUrl ? "https://stage.pehub.com" : "https://www.pehub.com";
    break;
  case "si":
    PEIURL = isStageUrl
      ? "https://stage.secondariesinvestor.com"
      : "https://www.secondariesinvestor.com";
    break;
  case "agri":
    PEIURL = isStageUrl ? "https://stage.agriinvestor.com" : "https://www.agriinvestor.com";
    break;
  default:
    BRANDNAME = "pei";
    PEIURL = isStageUrl
      ? "https://stage.privateequityinternational.com"
      : "https://www.privateequityinternational.com";
    break;
}

export const URL: {
  shouldGenerateSitemap: boolean;
  brand: string;
  brandURL: string;
  environment: string;
  sessionid: string | undefined;
  baseURL: string;
  basePEIURL: string;
  headlineAllArticles: string;
  investmentAppetiteLink: {
    main: string;
    route: string;
  };
  commonRoute: string;
  routes: {
    blaize: string;
    relatedNews: string;
    contactInfo: string;
    fundManaged: string;
    fundCommitment: string;
    lpFundCommitment: string;
  };
} = {
  shouldGenerateSitemap: process.env.NEXT_PUBLIC_GENERATE_SITEMAP
    ? JSON.parse(process.env.NEXT_PUBLIC_GENERATE_SITEMAP.toLowerCase())
    : false,
  brand: BRANDNAME,
  brandURL: "https://pei.group/",
  environment: isStageUrl ? "stage" : "prod",
  sessionid: process.env.SESSION_ID,
  baseURL: BASEURL,
  basePEIURL: PEIURL,
  headlineAllArticles: `${PEIURL}?s=`,
  investmentAppetiteLink: {
    main: "/database/institution-profile/id/",
    route: "/lp-investment-appetite",
  },
  commonRoute: "/institutions/",
  routes: {
    blaize: "/blaize/datalayer",
    relatedNews: "/related-news",
    contactInfo: "/contact-info",
    fundManaged: "/funds-managed",
    fundCommitment: "/fund-commitments",
    lpFundCommitment: "/lp-fund-commitments",
  },
};
